<div class="container-fluid m-0 p-0" *ngIf="checkDataExist()">
    <div class="row">
        <div class="col-12 mt-4">
            <div class="border-bottom font-16 mb-3 text-bold">{{ "TAB_BASIC_DATA" | translate | titlecase }}</div>
        </div>
        <div class="col-12">
            <div class="row m-0 p-3 bg-light-grey">
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "FULL_NAME_ENGLISH" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.fullNameEn }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "FULL_NAME_ARABIC" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.fullNameAr }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "ADDRES_LINE_1_ENGLISH" | translate | titlecase }}</label>
                    <p class="cand-answer">{{(globals.lang == 'ar')? candData.addressL1Ar :
                        candData.addressL1En}}</p>
                </div>
                <!-- <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "ADDRES_LINE_1_ARABIC" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.addressL1Ar }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "ADDRES_LINE_2_ENGLISH" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.addressL2En }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "ADDRES_LINE_2_ARABIC" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.addressL2Ar }}</p>
                </div> -->
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "COUNTRY" | translate | titlecase }}</label>
                    <p class="cand-answer">{{(globals.lang == 'ar')? candData.countryNameAr :
                        candData.countryNameEn}}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "REGION" | translate | titlecase }}</label>
                    <p class="cand-answer">{{(globals.lang == 'ar')? candData.regionNameAr :
                        candData.regionNameEn}}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "PROVINCE" | translate | titlecase }}</label>
                    <p class="cand-answer">{{(globals.lang == 'ar')? candData.provinceNameAr :
                        candData.provinceNameEn}}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "CITY" | translate | titlecase }}</label>
                    <p class="cand-answer">{{(globals.lang == 'ar')? candData.cityNameAr :
                        candData.cityNameEn}}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "MARTIAL_STATUS" | translate | titlecase }}</label>
                    <p class="cand-answer">{{(globals.lang == 'ar')? candData.maritalStatusNameAr :
                        candData.maritalStatusNameEn}}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "PERSONAL_MOBILE_1" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.personalMob1 }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "PERSONAL_MOBILE_2" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.personalMob2 }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "EMERGENCY_MOBILE_1" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.emergencyMob1 }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "EMERGENCY_MOBILE_2" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.emergencyMob2 }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "EMERGENCY_CONTACT_1" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.emergencyContact1 }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "EMERGENCY_CONTACT_2" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.emergencyContact2 }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "MILITIRY_STATUS" | translate | titlecase }}</label>
                    <p class="cand-answer">{{(globals.lang == 'ar')? candData.militaryStatusNameAr :
                        candData.militaryStatusNameEn}}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "HOME_TELEPHONE" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.homeTel }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "ENGLISH_NOTES" | translate | titlecase }}</label>
                    <p class="cand-answer">{{(globals.lang == 'ar')? candData.sec1NotesAr :
                        candData.sec1NotesEn}}</p>
                </div>

                <!-- <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "ARABIC_NOTES" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.sec1NotesAr }}</p>
                </div> -->
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "BACHELOR_CERT" | translate | titlecase }}</label>
                    <p class="cand-answer"><a href="{{candData.bachlorCertFilenamePath }}" target="_blank">{{ "VIEW" |
                            translate | titlecase }}</a></p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "BACHELOR_CARD" | translate | titlecase }}</label>
                    <p class="cand-answer"><a href="{{candData.bachlorCardFilenamePath }}" target="_blank">{{ "VIEW" |
                            translate | titlecase }}</a></p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "NATIONAL_ID_FIle" | translate | titlecase }}</label>
                    <p class="cand-answer"><a href="{{candData.nIdFilenamePath }}" target="_blank">{{ "VIEW" |
                            translate | titlecase }}</a></p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "DATE_OF_BIRTH" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.dob }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "THANAWEYA_SCORE" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.bachlorScore }} ( {{candData.bachlorPercent}} % )</p>
                </div>

            </div>
        </div>
    </div>
</div>
<app-loader [show]="!checkDataExist()"></app-loader>